<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'
import SurrenderFormModal from './SurrenderFormModal.vue'

export default {
  components: { SurrenderFormModal },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    financeId: { type: Number, required: true },
    idModalPage: { type: String, default: '' },
  },

  data: () => ({
    surrenders: [],
  }),

  methods: {
    surrenderSent(response) {
      let surrenderIndex = this.surrenders.findIndex((surrender) => surrender.id === response.json.id)
      if (response.method === 'delete') {
        this.surrenders.splice(surrenderIndex, 1)
      } else {
        if (surrenderIndex === -1) {
          this.surrenders.push(response.json)
        } else {
          this.surrenders.splice(surrenderIndex, 1, response.json)
        }
      }
    },
    async getSurrenders() {
      return await this.getJSON(`surrenders/list?financeId=${this.financeId}`)
    },
  },

  async mounted() {
    this.surrenders = await this.getSurrenders()
  },
}
</script>
<template>
  <div class="surrender-list">
    <div class="table-responsive-sm">
      <table v-if="surrenders.length > 0" class="table table-striped table-hover fs-16">
        <thead>
          <tr>
            <th>{{ $t('surrender.list.entity') }}</th>
            <th>{{ $t('surrender.list.amount') }}</th>
            <th>{{ $t('surrender.list.amountReal') }}</th>
            <th>{{ $t('surrender.list.purchaseAmountReal') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="surrender in surrenders" :key="surrender.id">
            <td>{{ surrender.entity ? surrender.entity.name : '' }}</td>
            <td>{{ $n(Number(surrender.amount), 'currency') }}</td>
            <td>{{ $n(Number(surrender.amountReal), 'currency') }}</td>
            <td>{{ $n(Number(surrender.purchaseAmountReal), 'currency') }}</td>
            <td v-if="!user.isReadOnly" style="display: flex; justify-content: space-evenly">
              <SurrenderFormModal
                :finance-id="financeId"
                :surrender-id="surrender.id"
                method="patch"
                @surrenders-sent="surrenderSent"
              />
              <SurrenderFormModal
                v-if="!surrender.mainSurrender"
                :finance-id="financeId"
                :surrender-id="surrender.id"
                method="delete"
                @surrenders-sent="surrenderSent"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <SurrenderFormModal
        v-if="!user.isReadOnly && surrenders.length === 0"
        :finance-id="financeId"
        method="post"
        @surrenders-sent="surrenderSent"
      />
    </div>
  </div>
</template>
